import { AppStore } from '~/types/main.types';
import { ChartDesignerActionType } from '../../actions/chart-designer/designer.actions';

export class ChartDesignerService {
  public static $inject = ['RxStoreService'];

  constructor(private store: AppStore) {}

  minimizeChartPane() {
    this.store.dispatch({
      type: ChartDesignerActionType.MinimizeChartPane,
    });
  }

  maximizeChartPane() {
    this.store.dispatch({
      type: ChartDesignerActionType.MaximizeChartPane,
    });
  }

  minimizeDataPane(isVegasPivotTable = false) {
    this.store.dispatch({
      type: isVegasPivotTable
        ? ChartDesignerActionType.MinimizeTableDataPane
        : ChartDesignerActionType.MinimizeDataPane,
    });
  }

  maximizeDataPane(isVegasPivotTable = false) {
    this.store.dispatch({
      type: isVegasPivotTable
        ? ChartDesignerActionType.MaximizeTableDataPane
        : ChartDesignerActionType.MaximizeDataPane,
    });
  }
}
